import { $api } from "../generated/client";

type UseGetProductVariantsQueryOptions = {
  shopId: string;
  productId: string;
  enabled?: boolean;
};

export default function useGetProductVariants({
  shopId,
  productId,
  enabled = false,
}: UseGetProductVariantsQueryOptions) {
  return $api.useQuery(
    "get",
    "/shops/{shopId}/products/{productId}/variants",
    { params: { path: { shopId, productId } } },
    {
      // `enabled` belongs in this options argument: openapi-react-query only
      // forwards the third argument to the fetch and the query key, so passing
      // it there left the query firing with an empty productId.
      enabled: enabled && Boolean(productId),
      // A 404 here means the product is gone from Shopify — a definitive answer
      // the modal shows as such, so retrying just delays it (BBS-328).
      retry: (failureCount: number, error: unknown) => {
        const status = (error as { statusCode?: number } | null)?.statusCode;
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 2;
      },
    },
  );
}
